<template>
    <vx-selectable v-model="model"
        placeholder="Search Group"
        :reduce="option => option.value"
        :loading="loading"
        :options="response || []"
        @search="search"
        data-test="group-selectable">
        <template v-slot:option="option">
            <slot name="option" v-bind="option"></slot>
        </template>
    </vx-selectable>
</template>

<script setup>
import { VxSelectable } from '@voxie/frontend-components';
import { onUnmounted } from 'vue';
import { groupsClient } from '~/services';
import { useSearchRequest } from '~/composables/useSearchRequest';

const teamId = Spark.state.currentTeam.id;
const model = defineModel();

const props = defineProps({
    orgUnitId: {
        type: Number,
    },
})

const {
    loading,
    response,
    createSearch,
    cancelSearch,
    cancelKey,
} = useSearchRequest(groupsClient);

const search = createSearch(async (query) => {
    const { data } = await groupsClient.getGroups({ teamId, orgUnitId: props.orgUnitId }, {
        query: query,
        setup_required: 0,
    }, {
        cancelKey: cancelKey,
    });

    return data.data.map((group) => ({
        ...group,
        value: group.group_id,
        label: `${group.name} - ${group.group_id}`.trim()
    }));
});

// Initialize with empty search
search();

// Clean up on component unmount
onUnmounted(() => {
    cancelSearch();
});
</script>
